import React from "react";
import { Link } from "react-router-dom";
import Navbar, { ScrollIndicator } from "./Navbar";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";

// ── IMAGE PLACEHOLDERS ─────────────────────────────────────────
const IMAGES = {
  heroBg: "/images/imageweb_1.jpg",
  staff1: "/images/staff-1.jpg",
  staff2: "/images/staff-2.jpg",
  staff3: "/images/staff-3.jpg", 

}
// ──────────────────────────────────────────────────────────────

const STAFF = [
  {
    id: 1,
    name: "Budi Santoso",
    position: "Direktur Utama",
    img: IMAGES.staff1,
  },
  {
    id: 2,
    name: "Siti Rahayu",
    position: "Manajer Operasional",
    img: IMAGES.staff2,
  },
  {
    id: 3,
    name: "Ahmad Fauzi",
    position: "Manajer Keuangan",
    img: IMAGES.staff3,
  },
];

const LEGAL_DOCS = [
  { name: "Peraturan Desa Tentang Bumdes", size: "PDF • 2.5 MB", url: "#" },
  { name: "SK Pengurus Bumdes 2025", size: "PDF • 1.3 MB", url: "#" },
  { name: "NPWP Bumdes", size: "PDF • 509 KB", url: "#" },
  { name: "Laporan Keuangan 2024", size: "PDF • 3.1 MB", url: "#" },
];

export default function AboutUs({ isAdmin, AdminSection }) {
  return (
    <div className="min-h-screen bg-white font-serif page-transition">
      <style>{`
        .page-hero { height:420px; min-height:320px; position:relative; display:flex; align-items:center; justify-content:center; background-size:cover; background-position:center; overflow:hidden; }
        .page-hero-overlay { position:absolute; inset:0; background:linear-gradient(160deg,rgba(20,40,28,0.75) 0%,rgba(61,79,69,0.52) 60%,rgba(15,30,20,0.82) 100%); }
        .page-hero-content { position:relative; z-index:10; text-align:center; padding:64px 1.5rem 0; animation:pgFadeUp 0.9s ease 0.15s both; }
        @keyframes pgFadeUp { from{opacity:0;transform:translateY(24px)} to{opacity:1;transform:translateY(0)} }
      `}</style>
      <Navbar />
      <WhatsAppButton />

      {/* HERO */}
      <section
        className="page-hero"
        style={{ backgroundImage: `url(${IMAGES.heroBg})` }}
      >
        <div className="page-hero-overlay" />
        <div className="page-hero-content">
          <p
            style={{
              fontSize: ".62rem",
              letterSpacing: ".32em",
              color: "#b8c5ba",
              textTransform: "uppercase",
              marginBottom: "1rem",
            }}
          >
            BUM Desa Warga Dekat Bandung
          </p>
          <h1
            style={{
              fontSize: "clamp(2rem,4.5vw,3.4rem)",
              color: "#fff",
              fontWeight: 300,
              lineHeight: 1.18,
              marginBottom: "1rem",
            }}
          >
            Tentang Kami
          </h1>
          <p
            style={{
              fontSize: ".87rem",
              color: "rgba(255,255,255,.82)",
              maxWidth: "520px",
              margin: "0 auto",
              lineHeight: 1.75,
            }}
          >
            Mengenal lebih dekat BUM Desa Warga Dekat Bandung — sejarah, visi,
            dan orang-orang di baliknya.
          </p>
        </div>
        <ScrollIndicator targetId="about-section" />
      </section>

      {/* HISTORY */}
      <section id="about-section" className="py-24 px-6 bg-white">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl text-center mb-12 text-[#3d4f45] font-light">
            Sejarah Kami
          </h2>
          <div className="space-y-5">
            {[
              {
                year: "2016",
                title: "Berdirinya BUMDes",
                desc: "BUM Desa Warga Dekat Bandung didirikan berdasarkan Peraturan Desa No. 3 Tahun 2016 dengan modal awal Rp 150 juta dari APBDes. Unit usaha pertama yang dijalankan adalah simpan-pinjam dan pengelolaan hasil kebun.",
              },
              {
                year: "2018",
                title: "Ekspansi Produk Kopi",
                desc: "Menyadari potensi besar perkebunan kopi di lereng Gunung Puhu, BUM Desa membentuk unit usaha pengolahan kopi. Produk Kopi Puhu mulai diperkenalkan ke pasar lokal Bandung dan mendapat respons sangat positif.",
              },
              {
                year: "2021",
                title: "Penghargaan Nasional",
                desc: "BUM Desa meraih penghargaan sebagai BUMDes Berprestasi Tingkat Nasional dari Kementerian Desa PDTT atas kontribusi dalam pemberdayaan ekonomi desa dan pengelolaan yang transparan dan akuntabel.",
              },
              {
                year: "2024",
                title: "Era Digital & Ekspansi Distribusi",
                desc: "BUM Desa masuk ke era digital dengan membangun platform e-commerce dan memperluas jaringan distribusi ke 12 kota besar di Indonesia. Unit usaha ekowisata Bukit Puhu juga resmi diluncurkan.",
              },
            ].map((item, i) => (
              <div
                key={i}
                className="flex items-start gap-6 p-6 border border-gray-100 rounded-xl hover:shadow-sm transition"
              >
                <div className="w-16 h-10 bg-[#3d4f45] text-white rounded-lg flex items-center justify-center text-xs font-bold flex-shrink-0">
                  {item.year}
                </div>
                <div>
                  <h3 className="font-semibold text-[#3d4f45] mb-1">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* VISION MISSION VALUES */}
      <section className="py-20 px-6 bg-[#f5f7f6]">
        <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-8">
          <div className="bg-white p-8 rounded-xl shadow-sm">
            <h2 className="text-lg font-semibold mb-4 text-[#3d4f45]">
              VISI KAMI
            </h2>
            <p className="text-gray-600 text-sm leading-relaxed">
              Menjadi Badan Usaha Milik Desa yang mandiri, profesional, dan
              berdaya saing tinggi dalam mengelola potensi lokal demi
              meningkatkan kesejahteraan seluruh masyarakat Desa Warga Dekat
              Bandung secara berkelanjutan.
            </p>
          </div>
          <div className="bg-white p-8 rounded-xl shadow-sm">
            <h2 className="text-lg font-semibold mb-4 text-[#3d4f45]">
              MISI KAMI
            </h2>
            <ul className="text-gray-600 text-sm leading-relaxed space-y-2">
              <li>
                • Mengoptimalkan sumber daya alam dan manusia desa secara
                bertanggung jawab.
              </li>
              <li>
                • Mengembangkan produk lokal bernilai tambah tinggi yang
                kompetitif di pasar nasional.
              </li>
              <li>
                • Membuka lapangan kerja dan meningkatkan pendapatan warga desa.
              </li>
              <li>
                • Mengelola usaha secara transparan, akuntabel, dan
                partisipatif.
              </li>
            </ul>
          </div>
          <div className="bg-white p-8 rounded-xl shadow-sm">
            <h2 className="text-lg font-semibold mb-4 text-[#3d4f45]">
              NILAI-NILAI KAMI
            </h2>
            <ul className="text-gray-600 text-sm leading-relaxed space-y-2">
              <li>
                • <strong>Kejujuran</strong> — Mengelola usaha dengan integritas
                penuh.
              </li>
              <li>
                • <strong>Kebersamaan</strong> — Tumbuh bersama, bukan
                sendiri-sendiri.
              </li>
              <li>
                • <strong>Inovasi</strong> — Terus belajar dan berkembang.
              </li>
              <li>
                • <strong>Keberlanjutan</strong> — Menjaga lingkungan untuk
                generasi mendatang.
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* STAFF */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl text-center mb-12 text-[#3d4f45] font-light">
            Pengurus BUM Desa
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            {STAFF.map((s) => (
              <div key={s.id} className="text-center">
                <div className="w-40 h-40 rounded-full mx-auto mb-5 overflow-hidden bg-gray-200 shadow-md border-4 border-[#f5f7f6]">
                  <img
                    src={s.img}
                    alt={s.name}
                    className="w-full h-full object-cover"
                    onError={(e) => (e.target.style.display = "none")}
                  />
                </div>
                <h3 className="text-lg font-semibold text-[#3d4f45]">
                  {s.name}
                </h3>
                <p className="text-sm text-gray-500">{s.position}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* LEGAL DOCS */}
      <section className="py-20 px-6 bg-[#f5f7f6]">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl text-center mb-10 text-[#3d4f45] font-light">
            Dokumen Legalitas
          </h2>
          <div className="space-y-3">
            {LEGAL_DOCS.map((doc, i) => (
              <div
                key={i}
                className="flex items-center justify-between bg-white px-6 py-4 rounded-xl border border-gray-100 hover:shadow-sm transition"
              >
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 bg-red-50 rounded-lg flex items-center justify-center text-red-500 flex-shrink-0">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                      <polyline points="14 2 14 8 20 8" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-800">
                      {doc.name}
                    </p>
                    <p className="text-xs text-gray-400">{doc.size}</p>
                  </div>
                </div>
                <a
                  href={doc.url}
                  className="text-sm text-[#3d4f45] font-medium hover:underline flex-shrink-0"
                >
                  Download
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 px-6 bg-[#f5f7f6]">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl mb-4 text-[#3d4f45] font-light">
            Tertarik Bermitra dengan Kami?
          </h2>
          <p className="text-gray-500 mb-8 text-sm leading-relaxed">
            Kami terbuka untuk kolaborasi, kemitraan usaha, dan program
            pemberdayaan bersama. Hubungi tim kami untuk informasi lebih lanjut.
          </p>
          <Link
            to="/contact"
            className="inline-block bg-[#3d4f45] text-white px-8 py-3 rounded-full text-sm hover:bg-[#4a5a50] transition"
          >
            HUBUNGI KAMI
          </Link>
        </div>
      </section>

      {isAdmin && (
        <div className="max-w-6xl mx-auto px-6 pb-8">
          <hr className="my-8 border-gray-200" />
          <AdminSection />
        </div>
      )}
      <Footer />
    </div>
  );
}
